import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { UIProvider } from './contexts/UIContext';
import Home from './pages/Home';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import Contact from './pages/Contact';
import RetryPayment from './pages/RetryPayment';
import AdminOrderDetail from './pages/AdminOrderDetail';
import AdminStats from './pages/AdminStats';
import AdminApify from './pages/AdminApify';
import AdminReminders from './pages/AdminReminders';
import AdminContacts from './pages/AdminContacts';
import AdminCardPayments from './pages/AdminCardPayments';

function App() {
  return (
    <UIProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/payment/:orderCode" element={<RetryPayment />} />
            <Route path="/backoffice" element={<AdminLogin />} />
            <Route path="/backoffice/login" element={<AdminLogin />} />
            <Route path="/backoffice/dashboard" element={<AdminDashboard />} />
            <Route path="/backoffice/order/:orderCode" element={<AdminOrderDetail />} />
            <Route path="/backoffice/stats" element={<AdminStats />} />
            <Route path="/backoffice/apify" element={<AdminApify />} />
            <Route path="/backoffice/reminders" element={<AdminReminders />} />
            <Route path="/backoffice/contacts" element={<AdminContacts />} />
            <Route path="/backoffice/card-payments" element={<AdminCardPayments />} />
          </Routes>
        </Router>
      </CartProvider>
    </UIProvider>
  );
}

export default App;
